module.exports = __webpack_public_path__ + "img/balance.bfc57f2c.png";